import Seo from "../components/seo";
import Layout from "../components/layout";
import Header from "../components/header";
import Footer from "../components/footer";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import ImageSection from "../components/ImageSection";
import CTASection from "../components/CTASection";
import FeaturedWork from "../components/FeaturedWork";
import { usePageMetadata } from "../hooks/usePageMetadata";

const IndexPage = () => {
  usePageMetadata({
    title: 'Bercastle - AI-First Agency',
    description: 'We are an AI-first agency building the technology behind innovative companies like OnScript AI.',
    pageType: 'homepage',
    content: {
      company: {
        name: "Bercastle",
        tagline: "AI-First Agency",
        description: "We are an AI-first agency building the technology behind innovative companies like OnScript AI. We specialize in cutting-edge artificial intelligence solutions that drive real business results.",
        contact: {
          email: "hello@bercastle.com"
        }
      },
      services: [
        {
          name: "AI Development",
          url: "/services/ai-development",
          summary: "Custom artificial intelligence solutions including machine learning, NLP, computer vision, and intelligent automation.",
          capabilities: ["Machine Learning", "Natural Language Processing", "Computer Vision", "Intelligent Automation"]
        },
        {
          name: "Media Technology",
          url: "/services/media-technology",
          summary: "AI-powered performance marketing, campaign optimization, and data analytics for media companies.",
          capabilities: ["Performance Marketing", "Campaign Optimization", "Data Analytics", "Audience Targeting"]
        },
        {
          name: "Voice & Telecom",
          url: "/services/voice-telecom",
          summary: "AI-enhanced voice technology and BPO call center services with quality control and monitoring.",
          capabilities: ["AI Voice Technology", "BPO Services", "Quality Control", "Infrastructure"]
        },
        {
          name: "AI for Startups",
          url: "/services/ai-for-startups",
          summary: "Prototype development and generative AI advisory for startups. Quick MVPs to validate demand.",
          capabilities: ["Prototype Development", "Generative AI Advisory", "Production Implementation"]
        },
        {
          name: "Vibe Coding Cleanup",
          url: "/services/vibe-coding",
          summary: "Code architecture review and cleanup for AI-generated code following industry best practices.",
          capabilities: ["Code Review", "Testing & QA", "Performance Optimization", "Security Hardening"]
        },
        {
          name: "AI/ML & Generative AI",
          url: "/services/ai-ml-generative",
          summary: "Custom AI copilots, machine learning models, and generative AI solutions.",
          capabilities: ["Custom AI Copilot", "Machine Learning", "Generative AI", "LLM Integration"]
        },
        {
          name: "Digital Transformation",
          url: "/services/digital-transformation",
          summary: "Strategy & roadmap for digital transformation with cloud migration and process automation.",
          capabilities: ["Strategy & Roadmap", "Cloud Migration", "Process Automation", "Data Analytics"]
        },
        {
          name: "Consulting",
          url: "/services/consulting",
          summary: "Technology consulting and software assessment. Architecture review and performance assessment.",
          capabilities: ["Technology Consulting", "Software Assessment", "Cloud Strategy", "AI Strategy"]
        },
        {
          name: "Business Intelligence",
          url: "/services/business-intelligence",
          summary: "Data integration, ETL workflows, and BI solutions for data-driven decision making.",
          capabilities: ["Data Integration & ETL", "Interactive Dashboards", "Advanced Analytics", "Data Warehousing"]
        },
        {
          name: "Cloud Development",
          url: "/services/cloud-development",
          summary: "Cloud-native applications with microservices, containers, and serverless architecture.",
          capabilities: ["Cloud-Native Apps", "Cloud Migration", "DevOps & CI/CD", "Multi-Cloud"]
        },
        {
          name: "Web Development",
          url: "/services/web-development",
          summary: "Responsive websites and custom web applications optimized for performance.",
          capabilities: ["Websites", "Web Applications", "E-commerce", "Progressive Web Apps"]
        },
        {
          name: "Mobile Development",
          url: "/services/mobile-development",
          summary: "iOS and Android mobile app development with beautiful design and robust engineering.",
          capabilities: ["iOS Development", "Android Development", "Cross-Platform"]
        }
      ],
      value_propositions: [
        "Expert team with deep technical expertise",
        "Proven track record with OnScript AI",
        "AI-first approach to every project",
        "Production-ready solutions that scale",
        "Strategic thinking combined with technical excellence"
      ],
      meta: {
        source_url: "https://bercastle.com/",
        page_type: "homepage"
      }
    }
  });

  return (
    <Layout classmain="homepage">
      <Seo
        title='Bercastle - AI-First Agency'
        metaDesciption='We are an AI-first agency building the technology behind innovative companies like OnScript AI.'
      />
      <div className="z-2 relative">
        <Header />

        <Hero />
        <About />
          
        <ImageSection />
        
        <Services />

        <FeaturedWork />

        <CTASection />
          
        <Footer />
      </div>
    </Layout>
  )
}

export default IndexPage
